(() => {
  function init(root) {
    if (root.dataset.initialized) return;
    root.dataset.initialized = 'true';

    const mobile = window.matchMedia('(max-width: 749px)');
    const designMode = root.dataset.designMode === 'true' || Boolean(window.Shopify?.designMode);
    const baseKey = root.dataset.storageKey || 'tet-floating-promo-state';
    const maxShows = Math.max(1, Number(root.dataset.maxShows) || 1);
    const interval = Math.max(1, Number(root.dataset.interval) || 60) * 1000;
    const fallback = new Map();
    let timer;

    const activeKey = () => `${baseKey}-${mobile.matches ? 'mobile' : 'desktop'}`;
    const emptyState = () => ({ count: 0, next: 0 });
    const read = () => {
      const key = activeKey();
      try {
        const value = JSON.parse(sessionStorage.getItem(key) || '{}');
        return {
          count: Math.max(0, Number(value.count) || 0),
          next: Math.max(0, Number(value.next) || 0),
        };
      } catch {
        return fallback.get(key) || emptyState();
      }
    };
    const write = (value) => {
      const key = activeKey();
      fallback.set(key, value);
      try { sessionStorage.setItem(key, JSON.stringify(value)); } catch {}
    };
    const enabled = () => (mobile.matches ? root.dataset.mobileEnabled : root.dataset.desktopEnabled) !== 'false';

    const schedule = () => {
      clearTimeout(timer);
      if (designMode) {
        root.hidden = !enabled();
        return;
      }
      if (!enabled() || !root.hidden || !root.isConnected) return;

      const state = read();
      if (state.count >= maxShows) return;

      const delaySeconds = Number(mobile.matches ? root.dataset.mobileDelay : root.dataset.delay) || 0;
      const delay = delaySeconds * 1000;
      timer = setTimeout(() => {
        const current = read();
        if (!enabled() || current.count >= maxShows || !root.isConnected) return;
        if (current.next > Date.now()) {
          schedule();
          return;
        }
        root.hidden = false;
        write({ count: current.count + 1, next: Date.now() + interval });
      }, Math.max(delay, state.next - Date.now(), 0));
    };

    root.querySelector('[data-tet-floating-promo-close]')?.addEventListener('click', () => {
      root.hidden = true;
      if (designMode) return;
      const state = read();
      write({ count: state.count, next: Date.now() + interval });
      schedule();
    });

    mobile.addEventListener('change', () => {
      if (!enabled()) root.hidden = true;
      schedule();
    });

    schedule();
  }

  document.querySelectorAll('[data-tet-floating-promo]').forEach(init);
  document.addEventListener('shopify:section:load', () => {
    document.querySelectorAll('[data-tet-floating-promo]').forEach(init);
  });
})();
